import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Icon } from '@famly/mf_data-display_icon';
import { Text } from '@famly/mf_data-display_text';
import { Box } from '@famly/mf_layout_box';
import { Stack } from '@famly/mf_layout_stack';
import { Tooltip } from '@famly/mf_data-display_tooltip';
import { useOnClickOutside } from '@famly/stat_use-on-click-outside';
import translate from 'signin-app/helpers/translate';
import { useBreakpoints } from '@famly/mf_util_breakpoints';
const Content = () => {
    return (_jsx(Box, { backgroundColor: "n25", color: "n400", children: _jsxs(Text, { variant: "body", children: [_jsx("strong", { children: translate('passwordHintLine1') }), _jsx("br", {}), translate('passwordHintLine2')] }) }));
};
export const PasswordTooltip = () => {
    const { isTabletPortraitAndLarger } = useBreakpoints();
    const [open, setOpen] = React.useState(false);
    const ref = React.useRef(null);
    useOnClickOutside(ref, () => setOpen(false), 
    // Clicks inside the tooltip popup (portaled outside the trigger) should not count as outside
    ['.MuiTooltip-tooltip'], undefined, undefined, 
    // Use the new selector behavior so the ignoreSelectors are matched against the click target's
    // ancestors only — the legacy behavior runs `querySelector` at every level (including document),
    // which always finds the portaled tooltip and prevents the outside-click callback from firing.
    true);
    return (_jsx(Tooltip, { variant: "info", placement: isTabletPortraitAndLarger ? 'right' : 'top-start', open: open, disableInteractive: false, tooltipContent: _jsx(Content, {}), children: _jsx(Stack, { ref: ref, position: "absolute", justifyContent: "center", alignItems: "center", right: 0, top: 0, width: "36px", height: "36px", cursor: "pointer", onClick: () => setOpen(current => !current), children: _jsx(Icon, { name: "help", filled: true, size: 24, color: "n0" }) }) }));
};
